export default __webpack_public_path__ + "static/media/logo-2.4035e253.webp";